export default {
color: `
<ow-icon name="setting" color="#DE4561"></ow-icon>
<ow-icon name="remove" color="#3B9CE1"></ow-icon>
<ow-icon name="user" color="#FFC429"></ow-icon>`,
loading: `
<ow-icon name="loading" :is-loading="true"></ow-icon>`
}
